<template>

  <div class="container">
    <b-card title="Search" class="margin-bottom">

      <b-form @submit="onSubmit" @reset="onReset" class="row">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <b-form-group label="Company Name:" label-for="companyName">
            <b-form-input id="companyName" v-model="form.companyName" type="text">
            </b-form-input>
          </b-form-group>

          <b-form-group label="Vendor:" label-for="vendor">
            <b-form-input id="vendor" v-model="form.vendor" type="text">
            </b-form-input>
          </b-form-group>

          <b-form-group label="Company Number:" label-for="companyNumber">
            <b-form-input
              id="companyNumber"
              v-model="form.companyNumber"
              type="text"
            >
            </b-form-input>
          </b-form-group>

          <b-form-group label="Telephone Number:" label-for="telephoneNumber">
            <b-form-input
              id="telephoneNumber"
              v-model="form.telephoneNumber"
              type="text"
            >
            </b-form-input>
          </b-form-group>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <b-form-group label="Postcode:" label-for="postcode">
            <b-form-input id="postcode" v-model="form.postcode" type="text">
            </b-form-input>
          </b-form-group>

          <b-form-group label="Email Address:" label-for="emailAddress">
            <b-form-input
              id="emailAddress"
              v-model="form.emailAddress"
            >
            </b-form-input>
          </b-form-group>

          <b-form-group label="Status:" label-for="status">
            <b-form-select v-if="lookups"
              id="tier"
              v-model="form.status"
              :options="companyStatuses"
              value-field="id"
              text-field="name"
            ></b-form-select>
          </b-form-group>

          <b-form-group label="Tier:" label-for="tier">
            <b-form-select v-if="lookups"
              id="tier"
              v-model="form.tier"
              :options="companyTiers"
              value-field="id"
              text-field="randdName"
            ></b-form-select>
          </b-form-group>

          <FeedbackButton title="Search" icon="search" :busy="isBusy" :onClick="clickSearch"/>

          <b-button type="reset" variant="info"
            ><font-awesome-icon icon="eraser" /> Clear</b-button
          >
          <b-button type="button" variant="light" @click="exportSearch" :disabled="!searchResults || searchResults.length == 0"
            ><font-awesome-icon icon="download" /> Export</b-button
          >
        </div>
      </b-form>
    </b-card>

    <div class="row" v-if="!searchResults || searchResults.length == 0">
      <div class="col-sm-12 margin-top">
        <b-alert show><strong>No Search Results</strong></b-alert>
      </div>
    </div>

    <b-card :title="'Search Results (' + this.rows + ')'" class="margin-bottom" v-if="searchResults && searchResults.length > 0">
      <div class="row" v-if="searchResults && searchResults.length > 0">

        <b-table
          striped
          hover
          :items="searchResults"
          :fields="fields"
          :current-page="currentPage"
          :per-page="0"
          :busy.sync="isBusy"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          no-local-sorting
          @sort-changed="sortingChanged"
        >
          <template slot="head(exportId)">
            <b-form-checkbox v-model="toggleAll"></b-form-checkbox>
          </template>

          <template v-slot:cell(exportId)="data">
            <b-form-checkbox :value="data.item.companyId" v-model="form.exportIds"></b-form-checkbox>
          </template>

          <template v-slot:cell(company)="data">
            {{ data.item.companyName }}<br />{{ data.item.postcode }}
          </template>

          <template v-slot:cell(contact)="data">
            <div>
              {{ data.item.primaryContactTitle }}
              {{ data.item.primaryContactFirstName }}
              {{ data.item.primaryContactLastName }}
            </div>
            <div v-bind:class="{ red: data.item.primaryContactTelephoneNumberCtps }">
              {{ data.item.primaryContactTelephoneNumber }}
            </div>
          </template>

          <template v-slot:cell(contacted)="data">
            <div>{{ data.item.LastContacted }}</div>
            <div>{{ data.item.LastContactedBy }}</div>
          </template>

          <template v-slot:cell(status)="data">
            <div>{{ data.item.status }}</div>
            <div>{{ data.item.owner }}</div>
            <div v-if="data.item.hasCallback">
              <strong>Callback:</strong> {{ data.item.callbackDate }}
              {{ data.item.callbackTime }}
            </div>
          </template>

          <template v-slot:cell(tier)="data">
            {{ data.item.companyTier }}
          </template>

          <template v-slot:cell(nav)="data">
            <router-link :to="'/company/' + data.item.companyId" tag="button" class="details btn btn-warning btn-xs"
              :disabled="!data.item.allowedCall">
            <font-awesome-icon icon="edit" /> Details
            </router-link>


            <button
              class="details btn btn-info btn-xs"
              :disabled="!data.item.allowedCall"
              type="button"
              @click="transferCompany(data.item.companyId)"
            >
              <font-awesome-icon icon="exchange" /> Transfer
            </button>
          </template>
        </b-table>

        <div class="col-sm-12">
          <b-alert :show="showNoResults">
            <strong>No Results.</strong> Search criteria found no results.
            <b-button type="button" variant="primary" @click="addcompany"><font-awesome-icon icon="plus" />&nbsp;Add Company</b-button>
          </b-alert>
        </div>

        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="10"
          first-number
          last-number
        ></b-pagination>
      </div>
    </b-card>
    <CompanyTransferCreateModal :companyId="selectedCompanyId" ref="companyTransferCreateModal"/>
  </div>

</template>

<script>
import FeedbackButton from "@/components/shared/FeedbackButton.vue";
import CompanyTransferCreateModal from "@/components/shared/CompanyTransferCreateModal.vue";
import LookupsService from '@/services/Lookups.service'
import SearchService from '@/services/Search.service'

export default {
  components: { CompanyTransferCreateModal, FeedbackButton },
  data() {
    return {
      form: {
        companyName: "",
        vendor: "",
        companyNumber: "",
        telephoneNumber: "",
        postcode: "",
        emailAddress: "",
        status: "",
        tier: "",
        pageNo: 1,
        pageSize: 10,
        sortDirection: "",
        sortColumn: "",
        exportIds: []
      },
      searchResults: [],
      allSearchResults: [],
      fields: [
        { key: "exportId", label: "", sortable: false },
        { key: "company", label: "Company Name", sortable: true },
        { key: "contact", label: "Primary Contact", sortable: true },
        { key: "status", label: "Status/Owner", sortable: true },
        { key: "tier", label: "Tier", sortable: true },
        { key: "nav", label: "", sortable: false },
      ],
      currentPage: 1,
      rows: 0,
      isBusy: false,
      sortBy: "",
      sortDesc: false,
      selectedCompanyId: null,
      lookups: null,
      toggleAll: false,
      showNoResults: false
    };
  },
  created() {
    LookupsService.loadLookups().then(result => {
      this.lookups = result.data;
    })
  },
  watch: {
    toggleAll: {
      handler: function() {
        if (this.toggleAll) {
          this.form.exportIds = [];
          this.allSearchResults.forEach((r) => {
            this.form.exportIds.push(r.companyId);
          });
        }
        else {
          this.form.exportIds = [];
        }
      }
    },
    currentPage: {
      handler: function () {
        this.form.pageNo = this.currentPage;

        this.search()
          .then((result) => {
            if (result){
              this.searchResults = result.searchResults;
            this.allSearchResults = result.allSearchResults;
            this.rows = result.totalResults;
            }            
          })
          .catch((error) => {
            console.error(error);
          });
      },
    },
  },
  computed: {
    companyTiers() {
      if (!this.lookups) return [{ id: null, randdName: ""}];

      var tiers = [...this.lookups.companyTiers];

      if (tiers[0].id == 0) {
        tiers.shift();
      }
      return [{ id: null, randdName: ""}, ...tiers];
    },
    companyStatuses() {
      if (!this.lookups) return [{id: null, name: ""}];
      return [{id: null, name: ""}, ...this.lookups.companyStatuses];
    },

  },

  methods: {
    addcompany() {
      this.$router.push('createcompany');
    },
    clickSearch() {
      this.form.pageNo = 1;
      this.search();
    },
    async search() {

      if (!this.validateForm())
        return {searchResults: [], allSearchResults: [], totalResults: 0}

      this.isBusy = true;

      SearchService.search(this.form).then(response => {
        this.isBusy = false;
        this.searchResults = response.data.searchResults;
        this.allSearchResults = response.data.allSearchResults;
        this.rows = response.data.totalResults;
        this.showNoResults = (response.data && response.data.searchResults.length == 0);
      }).catch(() => {
        this.isBusy = false;
      });
    },
    async exportSearch() {

      this.isBusy = true;
      if (!this.validateForm())
        return {searchResults: [], allSearchResults: [], totalResults: 0}
      const response = await this.$http.post("/search/export", this.form, );
      this.isBusy = false;

      if(response.data != null) {
        var csvElement = document.createElement('a');
        csvElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(response.data);
        csvElement.target = '_blank';
        csvElement.download = 'search.csv';
        csvElement.click();
      }

    },
    async sortingChanged(ctx) {
      switch (ctx.sortBy) {
        case "company":
          this.form.sortColumn = "CompanyName";
          break;
        case "contact":
          this.form.sortColumn = "PrimaryContactLastName";
          break;
        case "status":
          this.form.sortColumn = "Status";
          break;
        case "tier":
          this.form.sortColumn = "CompanyTier";
          break;
      }
      this.currentPage = 0;
      this.form.sortDirection = ctx.sortDesc ? "ASC" : "DESC";

      this.search();
    },
    async onSubmit(evt) {
      evt.preventDefault();
      this.search();
    },
    validateForm() {

      if (
        this.form.companyName != "" ||
        this.form.vendor != "" ||
        this.form.companyNumber != "" ||
        this.form.telephoneNumber != "" ||
        this.form.postcode != "" ||
        this.form.emailAddress != "" ||
        this.form.status != "" ||
        this.form.tier != ""
      )
        return true;

      return false;
    },
    onReset() {
       this.form = {
        companyName: "",
        vendor: "",
        companyNumber: "",
        telephoneNumber: "",
        postcode: "",
        emailAddress: "",
        status: null,
        tier: null,
        pageNo: 1,
        pageSize: 10,
        sortDirection: "",
        sortColumn: "",
      }
      this.currentPage = 1;
      this.searchResults = [];
      this.allSearchResults = [];
      this.rows = 0;
      this.form.exportIds = [];
    },
    transferCompany(companyId) {
      this.selectedCompanyId = companyId;
      this.$refs.companyTransferCreateModal.showModal();
    }
  },
};
</script>

<style scoped>
button {
  margin-right: 5px;
}
</style>
